/**
 * this module is a log to encapsulate festive seasons we would like
 * to show a special image or message to users
 *
 * SEASON CONFIG SCHEMA
 *
 * {
 *
 *   name: String, (Required)
 *   start: { month: Number, day: Number }, (Inclusive, Required)
 *   end: { month: Number, day: Number }, (Inclusive, Required)
 *
 *   greeting: String,
 *   confirmTimer: Number, (ms)
 *   border: {
 *     res: require(DataURI),
 *     className: String,
 *   },
 *
 *   overlays: [
 *     require(DataURI), (240 x 240 px)
 *   ],
 *
 * }
 *
 *
 *
 * JUST REMEMBER FOLKS
 *
 * - Easter changes every year
 *
 *
 */


import styles from './styles.scss';

const log = [

  {
    name: 'Christmas',
    start: { month: 12, day: 23 },
    end: { month: 12, day: 26 },
    greeting: 'Merry Christmas',
    confirmTimer: 10000,
    border: {
      res: require('./res/wreath.png'),
      className: styles.ChristmasWreath,
    },
    overlays: [
      require('./res/snow.png'),
    ],
  },

  {
    name: 'New Years Day',
    start: { month: 1, day: 1 },
    end: { month: 1, day: 3 },
    overlays: [
      require('./res/fireworks.png'),
    ],
  },

];

export default log;

/*
eslint
global-require: 0,
*/



// WEBPACK FOOTER //
// ./src/lib/seasons/config.js